import React from "react";
import { useNavigate } from "react-router-dom";

function LiveGiftsDemoPage() {
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/lives-show");
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999999,
        overflowY: "auto",
        background:
          "radial-gradient(circle at top right, rgba(0,242,255,0.24), transparent 30%), radial-gradient(circle at bottom left, rgba(255,0,90,0.18), transparent 32%), #03070d",
        color: "#fff",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <style>
        {`
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }

          @keyframes giftPop {
            0% { transform: scale(0.4); opacity: 0; }
            50% { transform: scale(1.2); opacity: 1; }
            100% { transform: scale(1); }
          }

          @keyframes coinFloat {
            0% { transform: translateY(0); opacity: 0; }
            30% { opacity: 1; }
            100% { transform: translateY(-200px); opacity: 0; }
          }

          @keyframes glowPulse {
            0%, 100% { box-shadow: 0 0 20px rgba(255,215,0,0.3); }
            50% { box-shadow: 0 0 50px rgba(255,215,0,0.9); }
          }

          .gift-main {
            animation: giftPop 1s ease;
          }

          .coin {
            position: absolute;
            font-size: 22px;
            animation: coinFloat 3s linear infinite;
          }

          .coin.c2 { left: 40%; animation-delay: 0.5s; }
          .coin.c3 { left: 60%; animation-delay: 1s; }
          .coin.c4 { left: 50%; animation-delay: 1.5s; }
        `}
      </style>

      {/* 🔙 RETOUR */}
      <button
        onClick={goBack}
        style={{
          position: "fixed",
          top: 22,
          left: 22,
          zIndex: 10000000,
          padding: "11px 18px",
          borderRadius: 16,
          border: "1px solid rgba(0,242,255,0.45)",
          background: "rgba(0, 12, 20, 0.9)",
          color: "#00f2ff",
          fontWeight: 900,
          cursor: "pointer",
          boxShadow: "0 0 18px rgba(0,242,255,0.25)",
        }}
      >
        ← Retour
      </button>

      <div
        style={{
          minHeight: "100vh",
          padding: "80px 18px 50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            fontSize: 42,
            margin: "0 0 12px",
            fontWeight: 900,
            textShadow: "0 0 22px rgba(255,215,0,0.75)",
            animation: "fadeUp 0.7s ease forwards",
          }}
        >
          🎁 Cadeaux virtuels
        </h1>

        <p
          style={{
            maxWidth: 760,
            color: "#ffeaa7",
            fontSize: 18,
            lineHeight: 1.6,
            marginBottom: 34,
            animation: "fadeUp 0.9s ease forwards",
          }}
        >
          Les spectateurs peuvent envoyer des cadeaux pendant le live pour
          soutenir les créateurs.
        </p>

        {/* 🎬 ZONE LIVE */}
        <div
          style={{
            width: "100%",
            maxWidth: 380,
            height: 600,
            borderRadius: 30,
            background: "linear-gradient(180deg, #0a1a2b, #01060c)",
            border: "1px solid rgba(255,215,0,0.4)",
            boxShadow: "0 0 50px rgba(255,215,0,0.2)",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* 🎥 LIVE */}
          <div
            style={{
              position: "absolute",
              top: 20,
              left: 20,
              background: "#ff005a",
              padding: "6px 12px",
              borderRadius: 999,
              fontWeight: 900,
              fontSize: 12,
              animation: "glowPulse 2s infinite",
            }}
          >
            LIVE
          </div>

          {/* 🎁 GROS CADEAU */}
          <div
            className="gift-main"
            style={{
              position: "absolute",
              top: "35%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontSize: 80,
            }}
          >
            🎁
          </div>

          {/* 💰 COINS QUI MONTENT */}
          <div className="coin" style={{ left: "30%", bottom: 80 }}>💰</div>
          <div className="coin c2" style={{ bottom: 60 }}>💰</div>
          <div className="coin c3" style={{ bottom: 70 }}>💰</div>
          <div className="coin c4" style={{ bottom: 90 }}>💰</div>

          {/* 💬 MESSAGE */}
          <div
            style={{
              position: "absolute",
              bottom: 80,
              left: 20,
              right: 20,
              padding: 12,
              borderRadius: 16,
              background: "rgba(0,0,0,0.4)",
              border: "1px solid rgba(255,215,0,0.3)",
              color: "#fff",
              fontSize: 14,
            }}
          >
            🎁 Sarah a envoyé un cadeau !
          </div>

          {/* INPUT */}
          <div
            style={{
              position: "absolute",
              bottom: 15,
              left: 15,
              right: 15,
              height: 45,
              borderRadius: 999,
              background: "rgba(0,0,0,0.5)",
              border: "1px solid rgba(255,215,0,0.3)",
              display: "flex",
              alignItems: "center",
              padding: "0 12px",
              color: "#ffeaa7",
              fontSize: 13,
            }}
          >
            Envoyer un cadeau...
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveGiftsDemoPage;
